import React, { Component } from "react";
import { withTranslation } from "react-i18next"; // Import withTranslation HOC
import Services from "./Services";
import "./Home.css";
import About from "./About";
import Price from "./Price";
import Gallery from "./Gallery";
import Contact from "./contact";
//import Shopworker from "./ShopWorker";
import AppointmentHomePage from "./AppointmentHomePage";
import ShopReview from "./shopReview";
import Banner from "./Banner";  

class Home extends Component {
  render() {
    
    return (
      <div>
       <Banner /> 
        {/* <ShopWorker /> */}
        <Services />
        <Price />
        <AppointmentHomePage />
        <Gallery />
        <ShopReview />
        <About />
        <Contact />
      </div>
    );
  }
}

export default withTranslation("global")(Home); // Wrap Home component with withTranslation HOC and pass "global" namespace
